import { inject, Signal } from '@angular/core';
import { SpaConfig, UnirCoreService } from '@unir/core';

export type PreparadorSpaconfig = SpaConfig & {
	universityCode: string;
};

export const injectSpaConfig = () => {
	const coreService = inject(UnirCoreService);
	return coreService.spaConfig as Signal<PreparadorSpaconfig | undefined | null>;
};
